// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"c8f83680","263":"df689e69","279":"85ac67d1","514":"85ac67d1","744":"c8f83680","914":"df689e69"}[chunkId] + ".chunk.css";
};